/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';
import {
  AddButton,
  Buttons,
  DeleteButton,
  UpdateButton,
} from '../../../components/Common/iComponents/iPopUp/IpopUp';
import { Button, FormGroup, Label, Modal, Progress, Spinner, TabContent, TabPane } from 'reactstrap';
import { Row, Col, Card, CardBody, Container, CardHeader } from 'reactstrap';
import { DripIcons, BoxIcons, MaterialIUIcon as materialIUKeys } from '../../../helpers/icons_helper';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { useDispatch, useSelector } from 'react-redux';
import { getClients, getPermissions, getRoles } from '../../../store/actions';
import * as iconsMaterialIU from '@mui/icons-material';
import MaterialIcon from '@mui/material/Icon';
import "./permissions.scss"
import Select from 'react-select';
import IButtonComponent from '../../../components/Common/iComponents/iButton/IButton';
import classnames from "classnames";
import Swal from 'sweetalert2';

const FormPermissions = ({
  selectedRow,
  onCreatePermission,
  onUpdatePermission,
  onDeletePermission,
  modalName
}: any) => {
  const [arrayUpdAdd, SetarrayUpdAdd] = useState<any>([]);
  const clientsRedux = useSelector((state: any) => state.clients.clients);
  const [form, setForm] = useState({
    id: '',
    nombre: '',
    descripcion: '',
    MCA_ACTIVO: false,
    url_menu: '',
    icon: 'bx bx-brush-alt',
    IDIOMA_ID: 1,
    orden: 1,
    padreId: '',
    EMPRESA_ID: [] as any[] | never[],
    identificator: 'Standard',
    URL: "",
    holisticsClientIdentificator: "",
    clientSecret: "",
    code: "",
    generic: false,
    excludedClientIds: [],
    excludedRoles: [],
    permisoGUID: "",
    JSONHollistics: "",
    pemissionsHollistics: "",
  });

  const [clients, setClients] = useState<any>([])
  const [flag, setflag] = useState<any>(true);
  const [modal_xlarge, setmodal_xlarge] = useState(false);
  const [myIcon, setMyIcon] = useState<any>('bx bx-brush-alt');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState(DripIcons);
  const [tab, setTab] = useState<string>('1');
  const [currentPageMaterialIcon, setCurrentPageMaterialIcon] = useState(1);
  const [materialIcon, setMaterialIcon] = useState<any>([]);
  const dispatch = useDispatch();
  const LenPage = 500;

  const { permissions } = useSelector((state: any) => state.Permissions);
  const { roles, isLoading } = useSelector((state: any) => state.Roles);
  const paginationPermission = { sizePerPage: 1000, page: 1 };
  const [totalPages, setTotalPages] = useState(Math.ceil(materialIUKeys.length / LenPage))
  let searchTimeout: NodeJS.Timeout | null = null;
  const renderItems = (mode?: any) => {
    const list = mode ? materialIUKeys : materialIcon
    setTotalPages(Math.ceil(list.length / LenPage))
    const startIndex = (currentPageMaterialIcon - 1) * LenPage;
    const endIndex = Math.min(startIndex + LenPage, list.length);

    const itemsToRender = list.slice(startIndex, endIndex);
    return itemsToRender;
  };

  useEffect(() => {

    if (form?.identificator === "Standard") {
      SetarrayUpdAdd([
        'nombre',
        'generic',
        'MCA_ACTIVO',
        'descripcion',
        'icon',
        'url_menu',
        '',
        'padreId',
        '',
        'IDIOMA_ID',
        '',
        'orden',
      ]);

    } else if (form?.identificator === "Holistics") {
      SetarrayUpdAdd([
        'nombre',
        'generic',
        'MCA_ACTIVO',
        'padreId',
        'icon',
        'orden',
        '',
        'URL',
        'holisticsClientIdentificator',
        'clientSecret',
        'JSONHollistics',
      ]);
    } else if (form?.identificator === "iFrame") {
      SetarrayUpdAdd([
        'nombre',
        'generic',
        'MCA_ACTIVO',
        'padreId',
        'icon',
        'orden',
        '',
        'code',
      ]);
    }

  }, [selectedRow?.identificator, form?.identificator]);

  useEffect(() => {
    setFilteredData(renderItems())
  }, [currentPageMaterialIcon, materialIcon]);

  useEffect(() => {
    let newClientsArray = clientsRedux;
    let clientIdsArray: any;
    if (form.padreId) {
      if (typeof form.padreId == "string") {
        const padreSplit = form.padreId.split("@@@");
        const nombre = padreSplit[0];
        const descripcion = padreSplit[1];
        clientIdsArray = permissions.filter((item: any) => item.nombre == nombre && item.descripcion == descripcion).map((item: any) => item.EMPRESA_ID)
        newClientsArray = clientsRedux.filter((client: any) => clientIdsArray.includes(client.id));
      } else {
        const permissionsProperties = permissions.find((item: any) => item.id == form.padreId);
        if (permissionsProperties) {
          clientIdsArray = permissions.filter((item: any) => item.nombre == permissionsProperties.nombre && item.descripcion == permissionsProperties.descripcion).map((item: any) => item.EMPRESA_ID)
          newClientsArray = clientsRedux.filter((client: any) => clientIdsArray.includes(client.id));
        }
      }
    }
    setClients(newClientsArray)
  }, [form.padreId]);

  useEffect(() => {
    setMaterialIcon(materialIUKeys)
  }, [])

  const handlePageChangeMaterial = (page: any) => {
    setCurrentPageMaterialIcon(page);
  };

  function removeBodyCss() {
    document.body.classList.add('no_padding');
  }
  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge);
    removeBodyCss();
  }

  useEffect(() => {
    if (clients.length === 0) {
      dispatch(getClients({}));
    }
    if (selectedRow) {
      if (!permissions) {
        dispatch(getPermissions({ pagination: paginationPermission }));
      }
      if (selectedRow.generic) {
        selectedRow.EMPRESA_ID = [];
      }
      const formatPadreId = permissions.find((item: any) => item.id == selectedRow.padreId)
      if (formatPadreId) selectedRow.padreId = formatPadreId.nombre + "@@@" + formatPadreId.descripcion;
      setForm(selectedRow);
      setMyIcon(selectedRow.icon);
    }
  }, [selectedRow]);

  useEffect(() => {
    dispatch(getPermissions({ pagination: paginationPermission }));
  }, []);

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };
  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };

  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: !form[n as keyof typeof form],
    });
  };

  function handleSearchDrip(event: any) {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredData = DripIcons.filter((icon: any) => {
      return icon.toLowerCase().includes(searchTerm.toLowerCase());
      // 'name' es el nombre de la propiedad en el objeto 'data' que se desea filtrar
    });

    setFilteredData(filteredData);
  }
  function handleSearchBox(event: any) {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredData = BoxIcons.filter((icon: any) => {
      return icon.toLowerCase().includes(searchTerm.toLowerCase());
    });
    setFilteredData(filteredData);
  }
  function handleSearchMaterial(event: any) {
    setCurrentPageMaterialIcon(1)
    const searchTerm = event.target.value.toLowerCase();
    setSearchTerm(searchTerm);

    if (searchTimeout !== null) {
      clearTimeout(searchTimeout);
    }

    searchTimeout = setTimeout(() => {
      if (!searchTerm) {
        setMaterialIcon(materialIUKeys)
        return;
      }

      const filteredData = materialIUKeys.filter((icon) => {
        return icon.toLowerCase().includes(searchTerm);
      });
      setMaterialIcon(filteredData)
    }, 1000);
  }

  function updateTabs(form: any) {
    let updatedTabs = [...tabs];

    if (form.generic) {
      updatedTabs[1] = {
        ...updatedTabs[1],
        name: "Excluded Clients"
      };
      if (!updatedTabs.some(tab => tab.name === "Excluded Roles")) {
        updatedTabs.push({
          icon: "dripicons-user-id",
          name: "Excluded Roles"
        });
      }
      updatedTabs = updatedTabs.filter(tab => tab.name !== "Save");
      if (flag) {
        updatedTabs.push({
          icon: !selectedRow ? "bx bx-plus-circle" : "bx bx-sync",
          name: "Save"
        });
      }
    } else {
      if (updatedTabs[1].name === "Excluded Clients") {
        updatedTabs[1] = {
          ...updatedTabs[1],
          name: "Select Client"
        };
      }
      updatedTabs = updatedTabs.filter(tab => tab.name !== "Excluded Clients" && tab.name !== "Excluded Roles");
      updatedTabs = updatedTabs.filter(tab => tab.name !== "Save");
      if (flag) {
        updatedTabs.push({
          icon: !selectedRow ? "bx bx-plus-circle" : "bx bx-sync",
          name: "Save"
        });
      }
    }

    setTabs(updatedTabs);
  }

  const renderButtons = () => (
    <Buttons>
      <AddButton
        disabled={!flag}
        className={flag ? "button" : "button-disable"}
        onClick={() => {
          toggleTabProgress(1);
          modalName("Permissions | " + tabs[1].name)

          const exist = tabs.some((tab: any) => tab.name === "Save")
          if (!exist) {
            setTabs([...tabs, {
              icon: !selectedRow ? "bx bx-plus-circle" : "bx bx-sync",
              name: "Save"
            },
            ])
          }
        }}
      >
        <i className="dripicons-checkmark" style={{ fontSize: '3em' }} />
      </AddButton>
      {selectedRow ? (
        <>
          <DeleteButton
            className="btn-delete"
            onClick={() => onDeletePermission(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
        </>
      ) : <></>}

    </Buttons>
  );


  //-------------------------------------------------------------------------------------------

  useEffect(() => {
    if (tab === '1') {
      setFilteredData(DripIcons);
    }
    else if (tab == '2') {
      setFilteredData(BoxIcons);
    }
    else {//Reiniciar
      setFilteredData(renderItems(true))
      setMaterialIcon(materialIUKeys)
      handlePageChangeMaterial(1)
    }
    setSearchTerm('');
  }, [tab, modal_xlarge]);

  useEffect(() => {
    const { nombre,
      url_menu,
      descripcion,
      URL,
      holisticsClientIdentificator,
      clientSecret,
      code,
      padreId,
      JSONHollistics
    } = form;

    let flagInfo = false;
    if (form?.identificator === "Standard") {
      flagInfo =
        nombre != '' &&
        descripcion != '' &&
        url_menu != '' &&
        padreId !== ''

    }
    if (form?.identificator === "Holistics") {
      flagInfo =
        URL != '' &&
        holisticsClientIdentificator != '' &&
        clientSecret != '' &&
        padreId !== '' &&
        JSONHollistics !== ''
    }
    if (form?.identificator === "iFrame") {
      flagInfo =
        nombre != '' &&
        code != '' &&
        padreId !== ''
    }
    setflag(flagInfo);
  }, [form]);

  useEffect(() => {
    if (flag) {
      updateTabs(form);
      setState({
        ...state,
        progressValue: form.generic ? 100 / 3 : 100 / 2
      });
    } else {
      updateTabs(form);
    }
  }, [flag]);



  const SetIncons = (iconVal: any) => {
    setmodal_xlarge(false);
    setMyIcon(iconVal);
    setForm({ ...form, icon: iconVal });
    setSearchTerm('');
    setTab('1');
  };
  const selectModals = () => {
    if (tab === '1') {
      return (
        <>
          <Container>
            <Row>
              <Col xs="12">
                <Card>
                  <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>Drip Icons</h2>
                    <div className="search__container">
                      <input
                        type="search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchDrip}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row className="icon-demo-content">
                      {filteredData.map((icon: any) => {
                        return (
                          <Col
                            xl={3}
                            lg={4}
                            sm={6}
                            onClick={() => SetIncons(icon)}
                          >
                            <i className={icon}></i> {icon}
                          </Col>
                        );
                      })}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      );
    }
    else if (tab == '2') {
      return (
        <>
          <Container>
            <Row>
              <Col xs="12">
                <Card>
                  <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>Box Icons</h2>
                    <div className="search__container">
                      <input
                        type="search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchBox}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row className="icon-demo-content">
                      {filteredData.map((icon: any) => {
                        return (
                          <Col
                            xl={3}
                            lg={4}
                            sm={6}
                            onClick={() => SetIncons(icon)}
                          >
                            <i className={icon}></i> {icon}
                          </Col>
                        );
                      })}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      );
    }
    else if (tab == '3') {
      return (
        <>
          <Container>
            <Row>
              <Col xs="12">
                <Card>
                  <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>Material IU</h2>
                    <div className="search__container">
                      <input
                        type="search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchMaterial}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row className="icon-demo-content">
                      {filteredData.map((icon: any, index: any) => {
                        const iconComponent = iconsMaterialIU[icon as keyof typeof iconsMaterialIU];

                        if (iconComponent) {
                          return (
                            <Col xl={3} lg={4} sm={6}
                              key={index}
                              onClick={() => SetIncons(icon)}
                            >
                              <i><MaterialIcon component={iconComponent} /></i>{icon}
                            </Col>
                          );
                        } else {
                          return null;
                        }
                      })}
                      <div style={{ display: "flex", width: "100%", justifyContent: "end", alignItems: "center", boxSizing: "border-box", padding: "20px" }}>
                        {currentPageMaterialIcon > 1 ? (
                          <UpdateButton
                            className="button"
                            onClick={() => handlePageChangeMaterial(currentPageMaterialIcon - 1)}
                          >
                            Back
                          </UpdateButton>
                        ) : null}

                        {currentPageMaterialIcon < totalPages ? (
                          <UpdateButton
                            className="button"
                            onClick={() => handlePageChangeMaterial(currentPageMaterialIcon + 1)}
                          >
                            Next
                          </UpdateButton>
                        ) : null}
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )
    }
  };

  /* Client new Array Form */

  const [selectedClientIds, setSelectedClientIds] = useState<any>(null);
  const [excludedClientIds, setExcludedClientIds] = useState<any>(null);
  const [availableClientIds, setAvailableClientIds] = useState<any>(null);
  const [availableRoles, setAvailableRoles] = useState<any>(null);
  const [excludedRoles, setExcludedRoles] = useState<any>(null);
  const [filteredRoles, setFilteredRoles] = useState<any>({ available: [], excluded: [] });
  const [filteredClientIds, setFilteredClientIds] = useState<any>({ available: [], selected: [], excluded: [] });
  const [query, setQuery] = useState<any>({
    available: undefined,
    selected: undefined,
    excluded: undefined,
    availableRol: undefined,
    excludedRol: undefined
  });

  const [openModalClientIds, setOpenModalClientIds] = useState(false);

  useEffect(() => {
    let availableClientsArray = []
    let excludedClientsArray = []
    let selectedClientsArray = []
    let availableRolesArray = []
    let excludedRolesArray = []
    if (selectedRow?.generic || form.generic) {
      excludedClientsArray = clients.filter((item: any) => selectedRow?.excludedClientIds.includes(item.id)).sort((a: any, b: any) => a.id - b.id);
      availableClientsArray = clients.filter((item: any) => !selectedRow?.excludedClientIds.includes(item.id)).sort((a: any, b: any) => a.id - b.id);

      excludedRolesArray = roles.filter((item: any) => selectedRow?.excludedRoles?.includes(item.id)).sort((a: any, b: any) => a.id - b.id);
      availableRolesArray = roles.filter((item: any) => !selectedRow?.excludedRoles?.includes(item.id)).sort((a: any, b: any) => a.id - b.id);
    } else {
      selectedClientsArray = clients.filter((item: any) => selectedRow?.EMPRESA_ID.includes(item.id)).sort((a: any, b: any) => a.id - b.id);
      availableClientsArray = clients.filter((item: any) => !selectedRow?.EMPRESA_ID.includes(item.id)).sort((a: any, b: any) => a.id - b.id);
    }

    setAvailableClientIds(availableClientsArray);
    setExcludedClientIds(excludedClientsArray);
    setSelectedClientIds(selectedClientsArray);
    setAvailableRoles(availableRolesArray);
    setExcludedRoles(excludedRolesArray);
    setFilteredClientIds({ available: availableClientsArray, selected: selectedClientsArray, excluded: excludedClientsArray });
    setFilteredRoles({ available: availableRolesArray, excluded: excludedRolesArray })
  }, [selectedRow, clients, roles]);

  useEffect(() => {
    if (form.generic) {
      if (selectedClientIds?.length > 0) setAllStateOfClientIds(clients.sort((a: any, b: any) => a.id - b.id), [], []);
      dispatch(getRoles({ pagination: paginationPermission }));
    }
    if (!form.generic) {
      if (excludedClientIds?.length > 0) setAllStateOfClientIds(clients.sort((a: any, b: any) => a.id - b.id), [], []);
      if (excludedRoles?.length > 0) setAllStateOfRoles(roles.sort((a: any, b: any) => a.id - b.id), []);
    }
    updateTabs(form)
    setState({
      ...state,
      progressValue: form.generic ? 100 / 3 : 100 / 2
    });
  }, [form.generic]);
  useEffect(() => {
    if (query.available != undefined) setFilteredClientIds({ ...filteredClientIds, available: filtersModal("available", availableClientIds) });
  }, [query.available]);
  useEffect(() => {
    if (query.availableRol != undefined) setFilteredRoles({ ...filteredRoles, available: filtersModal("availableRol", availableRoles, "nombre") });
  }, [query.availableRol]);
  useEffect(() => {
    if (query.excludedRol != undefined) setFilteredClientIds({ ...filteredClientIds, excluded: filtersModal("excludedRol", excludedRoles, "nombre") });
  }, [query.excludedRol]);
  useEffect(() => {
    if (query.selected != undefined) setFilteredClientIds({ ...filteredClientIds, selected: filtersModal("selected", selectedClientIds) });
  }, [query.selected]);
  useEffect(() => {
    if (query.excluded != undefined) setFilteredClientIds({ ...filteredClientIds, excluded: filtersModal("excluded", excludedClientIds) });
  }, [query.excluded]);

  const dragEvent = useRef<any | null>(null);
  const [draggingOver, setDraggingOver] = useState<string | null>(null);
  const filtersModal = (column: string, array: any, nameColum: any = "name") => {
    if (array) {
      const queryInput = query[column];
      let newArray: any = [];
      const arrayDataClean = [...array];
      newArray = arrayDataClean;
      if (queryInput) newArray = newArray.filter((item: any) => item[nameColum].toLowerCase().includes(queryInput.toLowerCase()));
      return newArray;
    }
  };
  const handleDragEnter = (column: string) => {
    setDraggingOver(column);
  };
  const handleDrop = (column: string) => {
    if (dragEvent.current) {
      const { array, index } = dragEvent.current;
      const draggedItem = array.find((item: any) => item.id === index);
      let available = availableClientIds;
      let selected = selectedClientIds;
      let excluded = excludedClientIds;

      if (form.generic) {
        if (column === 'dataClients') {
          if (!availableClientIds.some((item: any) => item.id === draggedItem.id)) {
            available = [...availableClientIds, draggedItem];
            excluded = excludedClientIds.filter((item: any) => item.id !== index);
          }
        } else if (column === 'excludedClientIDsArray') {
          if (!excludedClientIds.some((item: any) => item.id === draggedItem.id)) {
            excluded = [...excludedClientIds, draggedItem];
            available = availableClientIds.filter((item: any) => item.id !== index);
          }
        }
      } else {
        if (column === 'dataClients') {
          if (!availableClientIds.some((item: any) => item.id === draggedItem.id)) {
            available = [...availableClientIds, draggedItem];
            selected = selectedClientIds.filter((item: any) => item.id !== index);
          }
        } else if (column === 'clientIDsArray') {
          if (!selectedClientIds.some((item: any) => item.id === draggedItem.id)) {
            selected = [...selectedClientIds, draggedItem];
            available = availableClientIds.filter((item: any) => item.id !== index);
          }
        }
      }
      setAllStateOfClientIds(available, selected, excluded);
    }
    setDraggingOver(null);
  };
  const handleDropRol = (column: string) => {
    if (dragEvent.current) {
      const { array, index } = dragEvent.current;
      const draggedItem = array.find((item: any) => item.id === index);
      let available = availableRoles;
      let excluded = excludedRoles;

      if (form.generic) {
        if (column === 'dataRoles') {
          if (!availableRoles.some((item: any) => item.id === draggedItem.id)) {
            available = [...availableRoles, draggedItem];
            excluded = excludedRoles.filter((item: any) => item.id !== index);
          }
        } else if (column === 'excludedRolesArray') {
          if (!excludedRoles.some((item: any) => item.id === draggedItem.id)) {
            excluded = [...excludedRoles, draggedItem];
            available = availableRoles.filter((item: any) => item.id !== index);
          }
        }
      }
      setAllStateOfRoles(available, excluded);
    }
    setDraggingOver(null);
  };
  const addSelectedClient = (client: any) => {
    if (!form.generic && !selectedClientIds.some((item: any) => item.id === client.id)) {
      const available = availableClientIds.filter((item: any) => item.id !== client.id);
      const selected = [...selectedClientIds, client];
      setAllStateOfClientIds(available, selected, []);
    } else if (form.generic && !excludedClientIds.some((item: any) => item.id === client.id)) {
      const available = availableClientIds.filter((item: any) => item.id !== client.id);
      const excluded = [...excludedClientIds, client];
      setAllStateOfClientIds(available, [], excluded);
    }
  };
  const addSelectedRoles = (rol: any) => {
    if (!excludedRoles.some((item: any) => item.id === rol.id)) {
      const available = availableRoles.filter((item: any) => item.id !== rol.id);
      const excluded = [...excludedRoles, rol];
      setAllStateOfRoles(available, excluded)
    }
  };
  const RemoveExcludedRol = (rol: any) => {
    if (!availableRoles.some((item: any) => item.id === rol.id)) {
      const excluded = excludedRoles.filter((item: any) => item.id !== rol.id);
      const available = [...availableRoles, rol];
      setAllStateOfRoles(available, excluded)
    }
  };
  const RemoveSelectedClient = (client: any) => {
    if (!availableClientIds.some((item: any) => item.id === client.id)) {
      const selected = selectedClientIds.filter((item: any) => item.id !== client.id);
      const excluded = excludedClientIds.filter((item: any) => item.id !== client.id);
      const available = [...availableClientIds, client];
      setAllStateOfClientIds(available, selected, excluded);
    }
  };
  const setAllStateOfClientIds = (available: any, selected: any, excluded: any) => {
    const EMPRESA_ID = selected?.map((item: any) => item?.id);
    const excludedClientIds = excluded?.map((item: any) => item?.id);
    setAvailableClientIds(available);
    setSelectedClientIds(selected);
    setExcludedClientIds(excluded);
    setFilteredClientIds({ available: filtersModal("available", available), selected: filtersModal("selected", selected), excluded: filtersModal("excluded", excluded) });
    setForm({ ...form, EMPRESA_ID, excludedClientIds });
  };
  const setAllStateOfRoles = (available: any, excluded: any) => {
    const excludedRoles = excluded?.map((item: any) => item?.id);
    setAvailableRoles(available);
    setExcludedRoles(excluded);
    setFilteredRoles({ available: filtersModal("availableRol", available), excluded: filtersModal("excludedRol", excluded) });
    setForm({ ...form, excludedRoles });
  };
  const rowDropArea = (column: string, action: string) => {
    let mapItems: any = [];
    let arrayDragStart: any[] = [];
    if (column === "available") {
      mapItems = filteredClientIds?.available;
      arrayDragStart = availableClientIds;
    }
    if (column === "selected") {
      mapItems = filteredClientIds?.selected;
      arrayDragStart = selectedClientIds;
    }
    if (column === "excluded") {
      mapItems = filteredClientIds?.excluded;
      arrayDragStart = excludedClientIds;
    }
    if (column === "roles") {
      mapItems = filteredRoles.excluded;
      arrayDragStart = excludedRoles;
      return mapItems.map((rol: any, index: any) => {
        return (
          <Col
            className='pb-2'
            key={index}
            xl={12}
          >
            <Row
              draggable
              onDragStart={() => dragEvent.current = { array: arrayDragStart, index: rol.id }}
              onDragOver={(e) => e.preventDefault()}
              className="eventRow"
            >
              {
                action === "add" ?
                  <>
                    <Col
                      sm={9}
                      className="eventRowGrapPermissions eventRowName d-flex justify-content-center align-items-center">
                      <h4 className="fs-6 text-center">{rol.nombre}</h4>
                    </Col>
                    <Col
                      sm={3}
                      className=" eventRowOnClick bx-fade-right-hover"
                      onClick={() => addSelectedRoles(rol)}
                    >
                      <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-right' ></i>
                    </Col>
                  </>
                  :
                  <>
                    <Col
                      sm={3}
                      className=" eventRowOnClickRight bx-fade-left-hover"
                      onClick={() => RemoveExcludedRol(rol)}
                    >
                      <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-left' ></i>
                    </Col>
                    <Col
                      sm={9}
                      className="eventRowGrapPermissions eventRowName d-flex justify-content-center align-items-center">
                      <h4 className="fs-6 text-center">{rol.nombre}</h4>
                    </Col>
                  </>
              }
            </Row>
          </Col>
        );
      })
    }

    return mapItems.map((client: any, index: any) => {
      return (
        <Col
          className='pb-2'
          key={index}
          xl={12}
        >
          <Row
            draggable
            onDragStart={() => dragEvent.current = { array: arrayDragStart, index: client.id }}
            onDragOver={(e) => e.preventDefault()}
            className="eventRow"
          >
            {
              action === "add" ?
                <>
                  <Col
                    sm={9}
                    className="eventRowGrapPermissions eventRowName d-flex justify-content-center align-items-center">
                    <h4 className="fs-6 text-center">{client.id + " - " + client.name + " - " + client.company}</h4>
                  </Col>
                  <Col
                    sm={3}
                    className=" eventRowOnClick bx-fade-right-hover"
                    onClick={() => addSelectedClient(client)}
                  >
                    <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-right' ></i>
                  </Col>
                </>
                :
                <>
                  <Col
                    sm={3}
                    className=" eventRowOnClickRight bx-fade-left-hover"
                    onClick={() => RemoveSelectedClient(client)}
                  >
                    <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-left' ></i>
                  </Col>
                  <Col
                    sm={9}
                    className="eventRowGrapPermissions eventRowName d-flex justify-content-center align-items-center">
                    <h4 className="fs-6 text-center">{client.id + " - " + client.name + " - " + client.company}</h4>
                  </Col>
                </>
            }
          </Row>
        </Col>
      );
    })

  };
  const rowDropAreaRol = (column: string, action: string) => {
    let mapItems: any = [];
    let arrayDragStart: any[] = [];
    if (column === "available") {
      mapItems = filteredRoles?.available;
      arrayDragStart = availableRoles;
    }
    if (column === "excluded") {
      mapItems = filteredRoles?.excluded;
      arrayDragStart = excludedRoles;
    }
    return mapItems.map((rol: any, index: any) => {
      return (
        <Col
          className='pb-2'
          key={index}
          xl={12}
        >
          <Row
            draggable
            onDragStart={() => dragEvent.current = { array: arrayDragStart, index: rol.id }}
            onDragOver={(e) => e.preventDefault()}
            className="eventRow"
          >
            {
              action === "add" ?
                <>
                  <Col
                    sm={9}
                    className="eventRowGrapPermissions eventRowName d-flex justify-content-center align-items-center">
                    <h4 className="fs-6 text-center">{rol.nombre}</h4>
                  </Col>
                  <Col
                    sm={3}
                    className=" eventRowOnClick bx-fade-right-hover"
                    onClick={() => addSelectedRoles(rol)}
                  >
                    <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-right' ></i>
                  </Col>
                </>
                :
                <>
                  <Col
                    sm={3}
                    className=" eventRowOnClickRight bx-fade-left-hover"
                    onClick={() => RemoveExcludedRol(rol)}
                  >
                    <i className=' text-center d-flex justify-content-center eventIcon bx bxs-chevrons-left' ></i>
                  </Col>
                  <Col
                    sm={9}
                    className="eventRowGrapPermissions eventRowName d-flex justify-content-center align-items-center">
                    <h4 className="fs-6 text-center">{rol.nombre}</h4>
                  </Col>
                </>
            }
          </Row>
        </Col>
      );
    })


  };
  const selectClientIDs = () => {
    return (
      <>
        {
          <Container style={{ overflowX: "hidden", overflowY: "scroll", height: "650px", marginTop: -30, paddingRight: 5 }}>
            <Row>
              <Col xs="6"
                onDrag={() => handleDragEnter('dataClients')}
                onDrop={() => handleDrop('dataClients')}
                onDragOver={(e) => e.preventDefault()}
                className={`dropArea ${draggingOver === 'clientIDsArray' || draggingOver === 'excludedClientIDsArray' ? 'dragging-over' : ''}`}
              >
                <Card>
                  <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>Available Client IDs</h2>
                    <div className="search__container">
                      <input
                        type="search"
                        placeholder="Search..."
                        value={query.available}
                        onChange={(e) => setQuery({ ...query, available: e.target.value })}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      {rowDropArea("available", "add")}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="6"
                onDrag={() => handleDragEnter(form.generic ? 'excludedClientIDsArray' : 'clientIDsArray')}
                onDrop={() => handleDrop(form.generic ? 'excludedClientIDsArray' : 'clientIDsArray')}
                onDragOver={(e) => e.preventDefault()}
                className={`dropArea ${draggingOver === 'dataClients' ? 'dragging-over' : ''}`}
              >
                <Card>
                  <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>{form.generic ? "Excluded Client IDs" : "Selected Client IDs"}</h2>
                    <div className="search__container">
                      <input
                        type="search"
                        placeholder="Search..."
                        value={form.generic ? query.excluded : query.selected}
                        onChange={(e) => {
                          if (form.generic) {
                            setQuery({ ...query, excluded: e.target.value })
                          } else {
                            setQuery({ ...query, selected: e.target.value })
                          }
                        }}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      {rowDropArea(form.generic ? "excluded" : "selected", "remove")}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        }
      </>
    );
  };
  const excludedRolesRender = () => {
    return (
      <>
        {
          <Container style={{ overflowX: "hidden", overflowY: "scroll", height: "650px", marginTop: -30, paddingRight: 5 }}>
            <Row>
              <Col xs="6"
                onDrag={() => handleDragEnter('dataRoles')}
                onDrop={() => handleDropRol('dataRoles')}
                onDragOver={(e) => e.preventDefault()}
                className={`dropArea ${draggingOver === 'excludedRolesArray' ? 'dragging-over' : ''}`}
              >
                <Card>
                  <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>Available Roles</h2>
                    <div className="search__container">
                      <input
                        type="search"
                        placeholder="Search..."
                        value={query.availableRol}
                        onChange={(e) => setQuery({ ...query, availableRol: e.target.value })}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      {rowDropAreaRol("available", "add")}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="6"
                onDrag={() => handleDragEnter('excludedRolesArray')}
                onDrop={() => handleDropRol('excludedRolesArray')}
                onDragOver={(e) => e.preventDefault()}
                className={`dropArea ${draggingOver === 'dataRoles' ? 'dragging-over' : ''}`}
              >
                <Card>
                  <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>{"Excluded Roles"}</h2>
                    <div className="search__container">
                      <input
                        type="search"
                        placeholder="Search..."
                        value={query.excludedRol}
                        onChange={(e) => setQuery({ ...query, excludedRol: e.target.value })}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      {rowDropAreaRol("excluded", "remove")}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        }
      </>
    );
  };
  const optionsPadreId = () => {
    let newArray = [{
      label: "No PadreId",
      value: null
    }]

    const setNamePermission = new Set();
    newArray = [...newArray, ...permissions
      .map((item: any) => ({ value: item.nombre + "@@@" + item.descripcion, label: item.nombre }))
      .filter((item: any) => {
        if (setNamePermission.has(item.label)) {
          return false;
        } else {
          setNamePermission.add(item.label);
          return true;
        }
      })];
    return newArray.sort((a: any, b: any) => a.value - b.value);
  };
  const [buttonIconHover, setButtonIconHover] = useState(false);
  const handleMouseEnter = () => {
    setButtonIconHover(true);
  };
  const handleMouseLeave = () => {
    setButtonIconHover(false);
  };

  const checkJsonInCodeHollistics = (dataRegex: RegExp, type: any) => {
    const valid = Boolean(!dataRegex.exec(form.JSONHollistics))
    if (valid) {
      Swal.fire({
        icon: 'error',
        title: 'Variable Not Found',
        text: `The variable "${type}" was not found or is not an object in the provided code.`,
        showConfirmButton: true,
      })
    }
    return valid
  }

  const hollisticValidation = () => {
    if (checkJsonInCodeHollistics(
      /var\s+filters\s*=\s*{[\s\S]*?};/,
      "filters")) return false

    if (checkJsonInCodeHollistics(
      /var\s+permissions\s*=\s*[\s\S]*?;/,
      "permissions")) return false
    if (checkJsonInCodeHollistics(
      /['"]?row_based['"]?\s*:\s*[\s\S]*?;/,
      "row_based")) return false
    if (checkJsonInCodeHollistics(
      /['"]?path['"]?\s*:\s*{\s*/i,
      "path")) return false
    if (checkJsonInCodeHollistics(
      /['"]?dataset['"]?\s*:/i,
      "dataset")) return false
    if (checkJsonInCodeHollistics(
      /['"]?model['"]?\s*:/i,
      "model")) return false
    return true
  }

  // Ejemplo de uso
  const jsCode = `
  {
    filters: {
      name: 'test',
      value: 42
    }
  }
  `;

  /* Type Permissions */
  const identificator = ['Standard', 'Holistics', 'iFrame'];

  /* Wizard Step */
  const [tabs, setTabs] = useState([
    {
      icon: "dripicons-article",
      name: "Details Form"
    },
    {
      icon: "dripicons-user-group",
      name: "Select Clients"
    }
  ])
  const [state, setState] = useState<any>({
    activeTabProgress: 0,
    progressValue: 100 / tabs.length * 1,
    milestoneEventSH: [],
    selectedEvents: [],
    tabs: [{

    }]
  });
  const toggleTabProgress = (tab: any) => {
    if (tab >= 0 && tab < tabs.length) {
      setState({
        ...state,
        activeTabProgress: tab,
        progressValue: 100 / tabs.length * (tab + 1),
      });
    }

  };
  useEffect(() => {
    modalName("Permissions | " + tabs[0].name)
  }, []);
  const RenderWizardStep = () => {
    return (
      <>
        <div id="progrss-wizard" className="twitter-bs-wizard-permissions ">
          <ul className="twitter-bs-wizard-nav-permissions  nav-justified nav">
            {
              tabs.map((item, index) => {
                return (
                  <NavItem key={index}>
                    <NavLink
                      className={classnames("nav-link", {
                        active: state.activeTabProgress === index,
                        "hover-effect": form.generic ? index === 3 : index === 2,
                      })}
                      disabled={index === 1 && !flag}
                      onClick={() => {
                        let tabsNumbers = 2
                        const save = form.generic ? index === 3 : index === 2
                        if (save) {
                          const EMPRESA_ID = selectedClientIds?.map((item: any) => item?.id);
                          const excluded = excludedClientIds?.map((item: any) => item?.id);
                          let availableSave = true;
                          if (form.generic || form.EMPRESA_ID.length !== 0) {

                            if (form.identificator === "Holistics") {
                              availableSave = hollisticValidation()
                            }
                            if (availableSave) {
                              if (selectedRow) {
                                setForm(form.generic ? { ...form, excludedClientIds: excluded } : { ...form, EMPRESA_ID })
                                onUpdatePermission(form)
                              } else {
                                onCreatePermission(form)
                              }
                            }
                            return
                          }
                        } else if (form.generic) {
                          if (!selectedRow && !tabs.some((tab: any) => tab.name === "Save") && flag) {
                            setTabs([...tabs, {
                              icon: "bx bx-plus-circle",
                              name: "Save"
                            },
                            ])
                          }
                          tabsNumbers = 3

                        } else if (!tabs.some((tab: any) => tab.name === "Save") && flag) {
                          setTabs([...tabs, {
                            icon: "bx bx-plus-circle",
                            name: "Save"
                          },
                          ])

                        }


                        if (!save) {
                          if (index === 0) modalName("Permissions | " + item.name)
                          if (index === 1) modalName("Permissions | " + item.name)
                          setState({
                            ...state,
                            activeTabProgress: index,
                            progressValue: 100 / tabsNumbers * (index + 1)
                          });
                        }
                      }}
                    >
                      <div
                        className={classnames("step-icon cursor-pointer", {
                          "hover-effect": form.generic ? index === 3 : index === 2,
                        })}
                        style={index === 1 && !flag ? { color: "gray" } : {}}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={item.name}
                      >
                        <i className={item.icon}></i>
                      </div>
                      <div
                        className="step-title"
                      >
                        <strong>
                          {item.name}
                        </strong>
                      </div>
                    </NavLink>
                  </NavItem>
                )
              })
            }
          </ul>

          <div id="bar" className="pb-2" style={{ marginTop: -10 }} >
            <Progress
              color="primary"
              striped
              animated
              value={state.progressValue}
            />
          </div>
          <TabContent
            activeTab={state.activeTabProgress}
            className="twitter-bs-wizard-tab-content-permissions"
          >
            <TabPane tabId={0}>
              <Container
                style={{
                  position: "relative",
                  overflow: "auto",
                  height: 600,
                  paddingBottom: form.identificator === "Holistics" ? 100 : 0
                }}
              >
                <AvForm
                  className="custom-form mt-0"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(1, 1fr)`,
                    gridAutoRows: 'minmax(10%, 90px)',
                    gridGap: '2%',
                    marginLeft: '10%',
                    marginRight: '5%',
                  }}
                >
                  <FormGroup className=" d-flex justify-content-center align-items-center">
                    <div className='w-25'>
                      <div className="text-capitalize text-center">
                        <Label>Identificator</Label>
                      </div>
                      <Select
                        defaultValue={{ label: selectedRow?.identificator ?? 'Standard' }}
                        onChange={(e: any) => {
                          setForm({ ...form, identificator: e.label, padreId: "" });
                        }}
                        options={identificator.map((item: any) => {
                          return { label: item, value: item };
                        })}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </FormGroup>
                </AvForm>
                <div className='row ps-5 pe-5'>
                  {arrayUpdAdd?.map((val: any, index: any) => {
                    const nameObject = val as keyof typeof form;
                    const temp = form[nameObject];
                    const valid = temp ? true : false;
                    let type = '';
                    let nameSelector;
                    const value = itemVals(val, form) ?? "";
                    switch (val) {
                      case 'padreId':
                        nameSelector = selectedRow ?
                          value === null || value == "" ?
                            { nombre: "No PadreId", id: 0 } :
                            permissions.find((item: any) => {
                              if (typeof value === "number") {
                                return Number(item.id) === Number(value)
                              } else {
                                const valueSplit = value.split("@@@")
                                const name = valueSplit[0] ?? "";
                                const descripcion = valueSplit[1] ?? "";
                                return item.nombre == name && item.descripcion == descripcion
                              }
                            }) ??
                            { id: value, nombre: " Not Exist" }
                          : undefined;
                        return (
                          <>
                            <div className='col-6 pt-2'>
                              <Select
                                styles={{
                                  input: (provided: any) => ({ ...provided, height: '48px' }),
                                  menu: (provided: any) => ({ ...provided, maxHeight: '150px', zIndex: 99 }),
                                  menuList: (provided: any) => ({ ...provided, maxHeight: '150px' }),
                                }}
                                defaultValue={
                                  (value !== "" && value !== undefined) ?
                                    { value: nameSelector?.nombre + "@@@" + nameSelector?.descripcion, label: nameSelector?.nombre }
                                    :
                                    selectedRow ? { value: "No PadreId", label: 'No PadreId' } :
                                      { value: "Select PadreId", label: 'Select PadreId' }
                                }
                                onChange={(e: any) => {
                                  setForm({ ...form, [val]: e.value });
                                }}
                                options={optionsPadreId()}
                              />
                            </div>
                          </>
                        );
                      case 'EMPRESA_ID':
                        return (
                          <div className='col-6 d-flex justify-content-center align-items-center'>
                            <IButtonComponent
                              actionOnClick={() => {
                                setOpenModalClientIds(true);
                              }}
                              className="btn-search p-2"
                              label={form.generic ? "Exclude Clients" : "Select Clients"}
                            >
                            </IButtonComponent>
                          </div>
                        );
                      case 'MCA_ACTIVO':
                        return (
                          <div className='col-3'>
                            <FormGroup className="text-center">
                              <div className="text-capitalize">
                                <strong>{val.replace("MCA_ACTIVO", "Enable")}</strong>
                              </div>
                              <ISwitch
                                title={val}
                                checked={Boolean(form[nameObject])}
                                onChangeBooleanHandler={onChangeBooleanHandler}
                              />
                            </FormGroup>
                          </div>
                        );
                      case 'generic':
                        return (
                          <div className='col-3'>
                            <FormGroup className="text-center">
                              <div className="text-capitalize">
                                <strong>{val}</strong>
                              </div>
                              <ISwitch
                                title={val}
                                checked={Boolean(form[nameObject])}
                                onChangeBooleanHandler={onChangeBooleanHandler}
                              />
                            </FormGroup>
                          </div>
                        );
                      case 'IDIOMA_ID':
                        type = 'number';
                        break;
                      case 'orden':
                        type = 'number';
                        break;
                      case 'icon':
                        const isMaterial = (myIcon.slice(0, 2) == "bx" || myIcon.slice(0, 2) == "dr" || myIcon.includes(" "));
                        return (
                          <div
                            className={`col-6 d-flex justify-content-center align-items-center cursor-pointer`}
                            onClick={() => setmodal_xlarge(true)}
                          >
                            <FormGroup className="text-center ">
                              <Button
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                className={`btn-search d-flex justify-content-center align-items-center`}
                              >
                                <div className={` textButtonIcon ${buttonIconHover ? "pe-2 hovered" : ""}`}>{`${buttonIconHover ? "Icon" : ""}`}</div>
                                <i style={{ height: 30 }} className={`${isMaterial ? myIcon + " fs-3" : ""}`}>
                                  {!isMaterial ? <MaterialIcon component={iconsMaterialIU[myIcon as keyof typeof iconsMaterialIU]} /> : <div style={{ display: "none" }}></div>}
                                </i>
                              </Button>
                            </FormGroup>
                          </div>
                        );
                      case 'JSONHollistics':
                      case 'code':
                        type = 'textarea';
                        break;
                      default:
                        type = 'text';
                        break;
                    }
                    let sizeCol = "col-6"
                    if ((form.identificator === "iFrame" || form.identificator === "Holistics") &&
                      val !== "nombre" &&
                      val !== "orden") {
                      sizeCol = "col-12"
                    }
                    const sizeHeight = (form.identificator === "iFrame" && val !== "nombre" && val !== "orden") ||
                      val == "JSONHollistics";
                    return val ?
                      <div
                        className={"pt-2 " + sizeCol}
                        style={sizeHeight ? { height: 210 } : {}}
                        key={index}
                      >
                        <IInput
                          style={sizeHeight ? { height: 200 } : {}}
                          name={val
                            .replace("nombre", "Name")
                            .replace("descripcion", "Description")
                            .replace("orden", "Order")
                            .replace("IDIOMA_ID", "Language")
                            .replace("holisticsClientIdentificator", "Holistics Client Identificator")
                            .replace("clientSecret", "Client Secret")
                            .replace("code", "Code")
                            .replace("JSONHollistics", "Code JSON")
                            .replace(/_/g, ' ')
                          }
                          title={val}
                          valid={valid}
                          useValue={true}
                          value={value}
                          type={type}
                          onChangeHandler={onChangeHandler}
                        />
                      </div> :
                      <div className='col-6'></div>;
                  })}
                </div >
                <Modal
                  size="xl"
                  zIndex="20000000"
                  isOpen={modal_xlarge}
                  toggle={() => {
                    tog_xlarge();
                  }}
                >
                  <div style={{ maxHeight: "85vh" }} className="containerModal">
                    <button
                      onClick={() => {
                        setmodal_xlarge(false);
                      }}
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <Nav horizontal="end" tabs>
                      <NavItem>
                        <NavLink
                          className={`${tab === '1' ? 'active' : ''} btn`}
                          onClick={() => setTab('1')}
                        >
                          DripIcons
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={`${tab === '2' ? 'active' : ''} btn`}
                          onClick={() => setTab('2')}
                        >
                          BoxIcons
                        </NavLink>
                      </NavItem>


                      <NavItem>
                        <NavLink
                          className={`${tab === '3' ? 'active' : ''} btn`}
                          onClick={() => setTab('3')}
                        >
                          Material IU
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <div>{selectModals()}</div>
                  </div>
                </Modal>
              </Container>
              <div
                className='me-5'
                style={{
                  position: 'absolute',
                  display: "flex",
                  right: 1,
                  bottom: 50,
                  justifyContent: 'flex-end',
                }}
              >
                {renderButtons()}
              </div>
            </TabPane>

            <TabPane tabId={1}>
              {selectClientIDs()}
            </TabPane>

            <TabPane tabId={2}>
              {
                isLoading && roles.length === 0 ? <div className="d-flex pt-5 mt-5 justify-content-center align-items-center"><Spinner></Spinner></div> :
                  excludedRolesRender()}
            </TabPane>
          </TabContent>

        </div >
      </>
    )
  };
  return (
    <>
      {RenderWizardStep()}

    </>
  );
};

FormPermissions.propTypes = {
  selectedRow: PropTypes.object,
  onCreatePermission: PropTypes.func,
  onUpdatePermission: PropTypes.func,
  onDeletePermission: PropTypes.func,
  modalName: PropTypes.func
};

export default FormPermissions;
